import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./invoices.css";
import useAuth from "../../../hooks/useAuth";
import { toast } from "react-toastify";
import axiosInstance from "../../../helpers/axiosInstance";
import AuthorizedContent from "../../../shared/AuthorizedContent";
import FlipLoader from "../../../shared/fliploader/FlipLoader";
import { ReactComponent as ArrowIcon } from "../../../assets/signin/right.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/signin/delete.svg";
import { ReactComponent as PlusIcon } from "../../../assets/plus.svg";
import { ReactComponent as PendingIcon } from "../../../assets/pending.svg";
import { ReactComponent as CheckedIcon } from "../../../assets/check.svg";
import { motion, AnimatePresence } from "framer-motion";

function Invoices(props) {
  const [invoiceList, setInvoiceList] = useState([]);
  const { organisation, seesEveryone } = useAuth();
  const navigate = useNavigate();
  const [lineLoading, setLineLoading] = useState(false);

  const [invoiceLines, setInvoiceLines] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [membersList, setMembersList] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [invoiceItems, setInvoiceItems] = useState([{ item_name: "", item_price: "", item_quantity: 1 }]);
  const [numberOfMonths, setNumberOfMonths] = useState(1);
  const [invoiceType, setInvoiceType] = useState("future");
  const [isGenerating, setIsGenerating] = useState(false);
  useEffect(() => {
    if (!seesEveryone("invoices")) {
      fetchInvoices();
    } else {
        getAllInvoices();
    }
  }, []);

  useEffect(() => {
    if (showGenerateModal) {
      getAllMembersList();
    }
  }, [showGenerateModal]);
  const getAllInvoices = () => {
    axiosInstance
      .get(`/api/invoice/${organisation._id}/invoices`)
      .then((response) => {
        setInvoiceList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Unable to fetch invoices. Please try again!");
        console.error(error);
      });
  };

  const fetchInvoices = () => {
    axiosInstance
      .get(`/api/invoice/${organisation._id}/members/${props?.selectedMember?._id}/invoices`)
      .then((response) => {
        setInvoiceList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Unable to fetch invoices. Please try again!");
        console.error(error);
      });
  };



  const getAllInvoiceLines = (invoice_id) => {
    setLineLoading(true);
    axiosInstance
      .get(`/api/invoice_lines/${organisation._id}/invoices/${invoice_id}/lines`)
      .then((response) => {
        console.log("Invoice lines:", response.data);
        setInvoiceLines(response.data);
        setLineLoading(false);
      })
      .catch((error) => {
        setLineLoading(false);
        toast.error("Unable to fetch invoice lines. Please try again!");
        console.error(error);
      });
  }

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this invoice?")) {
      setLoading(true);
      axiosInstance
        .delete(`/api/invoice/${organisation._id}/delete/${id}`)
        .then(() => {
          toast.success("Invoice deleted successfully!");
          getAllInvoices();
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Failed to delete invoice. Please try again!");
          console.error(error);
        });
    }
  };

  const getAllMembersList = () => {
    axiosInstance
      .get(`/api/member/${organisation._id}/getallminimalmembers`)
      .then((response) => {
        setMembersList(response.data);
      })
      .catch((error) => {
        toast.error("Unable to fetch members. Please try again!");
        console.error(error);
      });
  };

  const handleAddItem = () => {
    setInvoiceItems([...invoiceItems, { item_name: "", item_price: "", item_quantity: 1 }]);
  };

  const handleRemoveItem = (index) => {
    const newItems = invoiceItems.filter((_, i) => i !== index);
    setInvoiceItems(newItems);
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...invoiceItems];
    newItems[index][field] = field === "item_quantity" ? parseInt(value) || 1 : value;
    setInvoiceItems(newItems);
  };

  const calculateTotal = () => {
    return invoiceItems.reduce((total, item) => {
      const price = parseFloat(item.item_price) || 0;
      const quantity = parseInt(item.item_quantity) || 1;
      return total + (price * quantity);
    }, 0);
  };

  const handleGenerateInvoice = () => {
    if (!selectedMember) {
      toast.error("Please select a member");
      return;
    }

    // Validation based on invoice type
    if (invoiceType === "future" && (!numberOfMonths || numberOfMonths < 1)) {
      toast.error("Please select valid number of months");
      return;
    }

    if (invoiceType === "other") {
      const validItems = invoiceItems.filter(item => item.item_name && item.item_price);
      if (validItems.length === 0) {
        toast.error("Please add at least one valid item");
        return;
      }
    }

    setIsGenerating(true);
    
    // Calculate due date based on number of months from today (only for future invoices)
    // let dueDate;
    // if (invoiceType === "future") {
    //   const today = new Date();
    //   dueDate = new Date(today.getFullYear(), today.getMonth() + numberOfMonths, today.getDate()).toISOString().split('T')[0];
    // } else {
    //   // For other types, set due date to today
    //   dueDate = new Date().toISOString().split('T')[0];
    // }
    if (invoiceType === "future") {
      const invoiceData = {
        months: numberOfMonths,
    };
      axiosInstance
      .post(`/api/invoice/${organisation._id}/members/${selectedMember}/createfutureinvoice`, invoiceData)
      .then((response) => {
        toast.success("Invoice generated successfully!");
        setShowGenerateModal(false);
        setSelectedMember("");
        getAllInvoices();
        setIsGenerating(false);
      })
      .catch((error) => {
        setIsGenerating(false);
        toast.error("Failed to generate invoice. Please try again!");
        console.error(error);
      });
    }
    

    // // Only include items and total for "other" invoice type
    if (invoiceType === "loan_closing") {
    axiosInstance
      .post(`/api/invoice/${organisation._id}/members/${selectedMember}/createloanclosinginvoice`)
      .then((response) => {
        toast.success("Invoice generated successfully!");
        setShowGenerateModal(false);
        setSelectedMember("");
        getAllInvoices();
        setIsGenerating(false);
      })
      .catch((error) => {
        setIsGenerating(false);
        toast.error("Failed to generate invoice. Please try again!");
        console.error(error);
      });
    }
  };

  const renderStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case 'paid':
        return (
          <span className="invoice-status-badge paid">
            <CheckedIcon className="invoice-status-icon" />
            Paid
          </span>
        );
      case 'unpaid':
        return (
          <span className="invoice-status-badge pending">
            <PendingIcon className="invoice-status-icon" />
            Unpaid
          </span>
        );
      default:
        return (
          <span className="invoice-status-badge">
            {status || 'N/A'}
          </span>
        );
    }
  };

  const renderInvoiceDetails = (invoice) => {
    return (
      <div className="invoice-details">
        <div className="invoice-detail-row">
          <span className="detail-label">Invoice #:</span>
          <span className="detail-value">{invoice.invoice_number || 'N/A'}</span>
        </div>
        <div className="invoice-detail-row">
          <span className="detail-label">Status:</span>
          <span className="detail-value">{renderStatusBadge(invoice.status)}</span>
        </div>
        <div className="invoice-detail-row">
          <span className="detail-label">Due Date:</span>
          <span className="detail-value">
            {invoice.due_date ? new Date(invoice.due_date).toLocaleDateString("en-us", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }) : 'N/A'}
          </span>
        </div>
        <div className="invoice-detail-row">
          <span className="detail-label">Amount:</span>
          <span className="detail-value amount">
            ₹{(invoice.total_amount || 0).toFixed(2)}
          </span>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="invoices-loader">
        <FlipLoader />
      </div>
    );
  }

  return (
    <div className="invoices-container">
      <div className="invoices-wrapper">
        <div className="invoices-header">
          <h2 className="invoices-heading">Invoices</h2>
          <AuthorizedContent feature="invoices" action="add">
            <button className="invoices-addiconbtn" onClick={() => setShowGenerateModal(true)}>
                        <PlusIcon />
                      </button>
          </AuthorizedContent>
        </div>
        
        <div className="invoices-listwrapper">
          {invoiceList.length === 0 ? (
            <div className="no-invoices">
              <p>No invoices found</p>
            </div>
          ) : (
            <AnimatePresence>
              {invoiceList.map((invoice) => (
                <motion.div
                  key={invoice._id}
                  className={`invoices-list ${invoice.status?.toLowerCase()}`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, x: -100 }}
                  transition={{ duration: 0.3 }}
                  // The invoice in full, with its receipt and the way to pay it.
                  onClick={() => navigate(`/admin/invoices/${invoice._id}`)}
                >
                  <div className="invoices-listleft">
                    <div className="invoices-list-header">
                      <h3>{invoice.invoice_number || 'N/A'}</h3>
                      {renderStatusBadge(invoice.status)}
                    </div>
                    <p>{invoice.member?.first_name + " " + invoice.member.last_name || 'N/A'}</p>
                    <span className="invoices-date">
                      Due: {invoice.due_date ? new Date(invoice.due_date).toLocaleDateString("en-us", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }) : 'N/A'}
                    </span>
                  </div>
                  <div className="invoices-listright">
                    <span className="invoices-amount">
                      ₹{(invoice.total_amount || 0).toFixed(2)}
                    </span>
                    <ArrowIcon className="invoices-arrow" />
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          )}
        </div>
      </div>

      <AnimatePresence>
        {showModal && selectedInvoice && (
          <motion.div 
            className="invoices-detailmodal-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="invoices-detailmodal">
              <header className="invoices-detailmodal-header">
                <button 
                  className="invoices-detailmodal-back"
                  onClick={() => setShowModal(false)}
                >
                  <ArrowIcon className="applyloan-modal-lefticon" />
                </button>
                <h3>Invoice Details</h3>
                <AuthorizedContent feature="invoices" action="delete">
                  <button 
                    className="invoices-detailmodal-delete"
                    onClick={() => handleDelete(selectedInvoice._id)}
                  >
                    <DeleteIcon />
                  </button>
                </AuthorizedContent>
              </header>
              
              <div className="invoices-detailmodal-content">
                {renderInvoiceDetails(selectedInvoice)}
                
                <div className="invoices-items">
                  <h4>Items</h4>
                  {invoiceLines.length > 0 ? (
                    <div className="invoices-items-list">
                      {invoiceLines.map((item, index) => (
                        <div key={index} className="invoices-item">
                          <div className="invoices-item-name">
                            {item.item_name || 'Unnamed Item'}
                          </div>
                          <div className="invoices-item-amount">
                            {item.item_quantity > 1 && `${item.item_quantity} × `}
                            ₹{(item.total_amount || 0).toFixed(2)}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>No items found</p>
                  )}
                </div>
              </div>
              
              <div className="invoices-detailmodal-total">
                <span>Total Amount:</span>
                <span className="invoices-total-amount">
                  ₹{(selectedInvoice.total_amount || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showGenerateModal && (
          <motion.div 
            className="invoices-generatemodal-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="invoices-generatemodal">
              <header className="invoices-generatemodal-header">
                <button 
                  className="invoices-generatemodal-back"
                  onClick={() => setShowGenerateModal(false)}
                >
                  <ArrowIcon className="applyloan-modal-lefticon" />
                </button>
                <h3>Generate New Invoice</h3>
              </header>
              
              <div className="invoices-generatemodal-content">
                <div className="invoices-generate-form">
                  <label>Invoice Type</label>
                  <select 
                    value={invoiceType} 
                    onChange={(e) => setInvoiceType(e.target.value)}
                    className="invoices-generate-select"
                  >
                    {/* <option value="future">Generate Future Invoice</option> */}
                    <option value="loan_closing">Generate Loan Closing Invoice</option>
                    {/* <option value="other">Other Invoice</option> */}
                  </select>
                </div>

                <div className="invoices-generate-form">
                  <label>Member</label>
                  <select 
                    value={selectedMember} 
                    onChange={(e) => setSelectedMember(e.target.value)}
                    className="invoices-generate-select"
                  >
                    <option value="">Select a member</option>
                    {membersList.map((member) => (
                      <option key={member._id} value={member._id}>
                        {member.full_name || `${member.first_name} ${member.last_name}`}
                      </option>
                    ))}
                  </select>
                </div>

                {invoiceType === "future" && (
                  <div className="invoices-generate-form">
                    <label>Number of Months</label>
                    <select 
                      value={numberOfMonths} 
                      onChange={(e) => setNumberOfMonths(parseInt(e.target.value))}
                      className="invoices-generate-select"
                    >
                      {[...Array(12)].map((_, index) => (
                        <option key={index + 1} value={index + 1}>
                          {index + 1} {index + 1 === 1 ? 'month' : 'months'}
                        </option>
                      ))}
                    </select>
                    <small style={{ color: '#718096', fontSize: '0.85rem', marginTop: '0.25rem', display: 'block' }}>
                      Due date will be calculated based on 10th of next month
                    </small>
                  </div>
                )}

                {invoiceType === "other" && (
                  <div className="invoices-generate-items">
                    <div className="invoices-generate-items-header">
                      <label>Items</label>
                      <button 
                        type="button" 
                        onClick={handleAddItem}
                        className="invoices-generate-additem"
                      >
                        <PlusIcon />
                      </button>
                    </div>
                    
                    {invoiceItems.map((item, index) => (
                      <div key={index} className="invoices-generate-item">
                        <input 
                          type="text"
                          placeholder="Item name"
                          value={item.item_name}
                          onChange={(e) => handleItemChange(index, 'item_name', e.target.value)}
                          className="invoices-generate-item-name"
                        />
                        <input 
                          type="number"
                          placeholder="Price"
                          value={item.item_price}
                          onChange={(e) => handleItemChange(index, 'item_price', e.target.value)}
                          className="invoices-generate-item-price"
                          min="0"
                          step="0.01"
                        />
                        <input 
                          type="number"
                          placeholder="Qty"
                          value={item.item_quantity}
                          onChange={(e) => handleItemChange(index, 'item_quantity', e.target.value)}
                          className="invoices-generate-item-quantity"
                          min="1"
                        />
                        {invoiceItems.length > 1 && (
                          <button 
                            type="button"
                            onClick={() => handleRemoveItem(index)}
                            className="invoices-generate-removeitem"
                          >
                            <DeleteIcon />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              <div className="invoices-generatemodal-footer">
                {invoiceType === "other" && (
                  <div className="invoices-generate-total">
                    <span>Total Amount:</span>
                    <span className="invoices-generate-total-amount">
                      ₹{calculateTotal().toFixed(2)}
                    </span>
                  </div>
                )}
                <div className="invoices-generate-actions">
                  <button 
                    className="invoices-generate-cancel"
                    onClick={() => setShowGenerateModal(false)}
                  >
                    Cancel
                  </button>
                  <button 
                    className="invoices-generate-submit"
                    onClick={handleGenerateInvoice}
                    disabled={isGenerating}
                  >
                    {isGenerating ? 'Generating...' : 'Generate Invoice'}
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Invoices;